module.exports = __webpack_public_path__ + "static/media/Load-25.1538b65e.svg";